import { create } from "zustand";

/**
 * Tour store (Zustand) — shared by every module's guided tour app-wide.
 *
 * 1. Registry: a module registers its tour opener via `registerTour(fn)` on
 *    mount and `clearTour()` on unmount. The global header help button reads
 *    `starter` — shown when set, hidden when null.
 *
 * 2. Cross-page tour phase: a generic baton for tours that span more than one
 *    page (a page's local useTourController state is lost on navigation). The
 *    two pages agree on a `crossPageTourPhase` string that says what the tour
 *    should do on the other page; e.g. Jobs Library sets a "job-details" phase
 *    when it sends the user to the Job Details page for one step, and that page
 *    sets a "finish" phase before navigating back so the origin page knows to
 *    resume at its Finish step. `clearCrossPageTourPhase()` resets it. Only one
 *    tour runs at a time, so a single field serves the whole app.
 *
 * Not persisted — everything is tied to the live, mounted modules.
 */
const useTourStore = create((set) => ({
  // ── Registry (global "Take the Tour" button) ──
  starter: null,
  registerTour: (starter) => set({ starter }),
  clearTour: () => set({ starter: null }),

  // ── Cross-page tour phase ──
  crossPageTourPhase: null,
  setCrossPageTourPhase: (crossPageTourPhase) => set({ crossPageTourPhase }),
  clearCrossPageTourPhase: () => set({ crossPageTourPhase: null }),
}));

export default useTourStore;
